<!-- ts schedule start-->
<section class="ts-schedule">
  <app-header></app-header>
            <a
              href="https://simplicity-unlocked.com/agenda_25Apr.pdf"
              class="w-100 btn btn-lg btn-primary"
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              Agenda
            </a>


  <div class="container pt-5">
    <!-- <div class="row pt-5">
      <div class="col-12">
        <img src="./assets/img/top.png" class="blob-left img-fluid" />
      </div>
    </div> -->
    <div class="row">
      <div class="col-lg-8 text-center mx-auto">
        <h2 class="section-title">
Registration          
        </h2>
      </div>
      <!-- col end-->
    </div>

    <!-- row end-->
    <div class="row px-2 py-5">
      <form #f="ngForm" (ngSubmit)="onSummit(f)">
        <div class="row" id="content">
          <div id="left_side" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
           <div class="form-group mb-3">
              <label class="form-label" for="Title"
                >Title <span class="red">*</span></label
              >
              <select
                name="title"
                ngModel
                #title="ngModel"
                class="form-control"
                id="Title"
                required
              >
                <option value="">Select</option>
                <option value="Dr.">Dr.</option>
                <option value="Mr.">Mr.</option>
                <option value="Ms.">Ms.</option>
                <option value="Mrs.">Mrs.</option>
              </select>

              <div
                *ngIf="
                  (title.value == '' && title.dirty) ||
                  (f.submitted && title.value == '')
                "
                class="alert alert-danger"
              >
                Title is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="form-label" for="name"
                >First Name<span class="red">*</span></label
              >
              <input
                name="name"
                type="text"
                 placeholder=""
                ngModel
                #name="ngModel"
                class="form-control"
                id="name"
                required
                minlength="3"
              />
              <div
                *ngIf="
                  (name.invalid && name.dirty) || (f.submitted && name.invalid)
                "
              >
                <div *ngIf="name.errors!.required" class="alert alert-danger">
                   Name is required
                </div>

                <div *ngIf="name.errors!.minlength" class="alert alert-danger">
                  Name minimum length must be 3 characters
                </div>
              </div>
            </div>
          <div class="form-group mb-3">
              <label class="form-label" for="lname"
                >Sur Name/Family Name  <span class="red">*</span></label
              >
              <input
                name="lname"
                type="text"
                ngModel
                #lname="ngModel"
                class="form-control"
                id="lname"
                required
                minlength="3"
              />
              <div
                *ngIf="
                  (lname.invalid && lname.dirty) ||
                  (f.submitted && lname.invalid)
                "
              >
                <div *ngIf="lname.errors!.required" class="alert alert-danger">
                  Last name is required
                </div>

                <div *ngIf="lname.errors!.minlength" class="alert alert-danger">
                  Last name minimum length must be 3 characters
                </div>
              </div>
            </div>
         <div class="form-group mb-3">
              <label class="form-label" for="Email"
                >Email ID <span class="red">*</span></label
              >
              <input
                name="email"
                ngModel
                #email="ngModel"
                type="email"
                class="form-control"
                id="Email"
                required
                email
                [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              />
              <div
                *ngIf="
                  (email.invalid && email.dirty) ||
                  (f.submitted && email.invalid)
                "
                class="alert alert-danger"
              >
                <div *ngIf="email.errors!.required">Email is required</div>
                <div *ngIf="email.errors!.email">
                  Email must be a valid email address
                </div>
              </div>
            </div>
           <div class="form-group mb-3">
              <label class="form-label" for="Mobile"
                >Mobile No. <span class="red">*</span></label
              >
              <input
                name="mobile"
                ngModel
                #mobile="ngModel"
                type="tel"
                
                class="form-control"
                id="Mobile"
                [ngClass]="{ 'is-invalid': f.submitted && mobile.invalid }"
              />
              <div
                *ngIf="
                  (mobile.invalid && mobile.dirty) ||
                  (f.submitted && mobile.invalid)
                "
                class="alert alert-danger"
              >
                Mobile No. is required
              </div>
            </div> 
            <div class="form-group mb-3">
              <label class="form-label" for="Specialty"
                >Specialty<span class="red">*</span></label
              >
              <select
                name="specialty_id"
                ngModel
                #specialty_id="ngModel"
                class="form-control"
                id="Specialty"
                required
              >
         
                <option value="">-- Select --</option>
                <ng-container *ngFor="let spec of specialties">
                  <option value="{{ spec.id }}">{{ spec.name }}</option>
                  <ng-template *ngIf="spec.subs.length > 0">
                    <optgroup value="" label="">
                      <option *ngFor="let sub of spec.subs" value="{{ sub.id }}">{{
                        sub.name
                      }}</option>
                    </optgroup>
                  </ng-template> 
                </ng-container>
              </select>
              <div
                *ngIf="
                  (specialty_id.value == '' && specialty_id.dirty) ||
                  (f.submitted && specialty_id.value == '')
                "
                class="alert alert-danger"
              >
                Specialty is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="form-label" for="SCFHSID">
                SCFHS ID <span class="red">*</span>
              </label>
              <input
                name="answer9"
                ngModel
                #answer9="ngModel"
                type="text"
                class="form-control"
                id="SCFHSID"
                required
              />
              <div
                *ngIf="
                  (answer9.invalid && answer9.dirty) ||
                  (f.submitted && answer9.invalid)
                "
                class="alert alert-danger"
              >
                SCFHS ID is required
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="form-label" for="Institute">Workplace<span class="red">*</span></label>
              <input
                name="institute"
                ngModel
                type="text"
                class="form-control"
                id="Institute"
                required
              />
          

            </div>
            <input type="hidden" name="country_id" ngModel="184" />

          <div>

          </div>
            <div class="form-group mb-3">
              <label class="form-label" for="City"
                >City <span class="red">*</span></label
              >
              <select
                name="city_id"
                ngModel
                #city_id="ngModel"
                class="form-control"
                id="City"
                required
              >
                <option value="">-- Select --</option>

                <option *ngFor="let cit of cities" value="{{ cit.id }}">
                  {{ cit.name }}
                </option>
              </select>
              <div
                *ngIf="
                  (city_id.value == '' && city_id.dirty) ||
                  (f.submitted && city_id.value == '')
                "
                class="alert alert-danger"

              >
                City is required


              </div>
             
                <div
  *ngIf="city_id.value && city_id.value != '2879'"
  class="alert alert-danger mt-3"
>
  In-person registration is available only for attendees from Riyadh.
  Kindly
  <a href="https://virtual.simplicity-unlocked.com/register">
    register virtually
  </a>.
</div>
              
            </div>
           <br>
           
           <!--<div *ngIf="city_id.value && city_id.value != '2879'" class="form-group mb-3">
              <h5><b>Travel & Logistics</b></h5>
              <br>
              <label class="form-label d-block">
                Do you require Air Ticket? <span class="red">*</span>
              </label>
              <p class="small text-muted mb-2">
                Note: Travel tickets to Riyadh will be arranged from the nearest airport, departing on the morning of 8th May and returning on 9th May. If unavailable, the closest option will be provided.
              </p>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="answer5"
                  ngModel
                  #answer5="ngModel"
                  id="air_ticket_yes"
                  value="Yes"
                  required
                />
                <label class="form-check-label" for="air_ticket_yes">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="answer5"
                  ngModel
                  #answer5="ngModel"
                  id="air_ticket_no"
                  value="No"
                  required
                />
                <label class="form-check-label" for="air_ticket_no">No</label>
              </div>
              <div
                *ngIf="f.submitted && answer5.invalid"
                class="alert alert-danger mt-2"
              >
                Air Ticket answer is required
              </div>

              <div *ngIf="answer5.value == 'Yes'" class="mt-3">
                <label class="form-label" for="national_id_passport_copy">
                  Upload National ID/ Passport Copy <span class="red">*</span>
                </label>
                <input
                  type="file"
                  name="national_id_passport_copy"
                  id="national_id_passport_copy"
                  class="form-control"
                  accept=".jpg,.jpeg,.png,.pdf"
                  required
                  (change)="onNationalIdPassportCopySelected($event)"
                />
              </div>
            </div>-->

          <!--  <div *ngIf="city_id.value && city_id.value != '2879'" class="form-group mb-3">
              <label class="form-label d-block">
                Do you require Accommodation? <span class="red">*</span>
              </label>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="answer6"
                  ngModel
                  #answer6="ngModel"
                  id="accommodation_yes"
                  value="Yes"
                  required
                />
                <label class="form-check-label" for="accommodation_yes">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="answer6"
                  ngModel
                  #answer6="ngModel"
                  id="accommodation_no"
                  value="No"
                  required
                />
                <label class="form-check-label" for="accommodation_no">No</label>
              </div>
              <div
                *ngIf="f.submitted && answer6.invalid"
                class="alert alert-danger mt-2"
              >
                Accommodation answer is required
              </div>
            </div>-->

            <!--<div *ngIf="city_id.value && city_id.value != '2879'" class="form-group mb-3">
              <label class="form-label d-block">
                Do you require Airport Transfer? <span class="red">*</span>
              </label>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="answer7"
                  ngModel
                  #answer7="ngModel"
                  id="airport_transfer_yes"
                  value="Yes"
                  required
                />
                <label class="form-check-label" for="airport_transfer_yes">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="answer7"
                  ngModel
                  #answer7="ngModel"
                  id="airport_transfer_no"
                  value="No"
                  required
                />
                <label class="form-check-label" for="airport_transfer_no">No</label>
              </div>
              <div
                *ngIf="f.submitted && answer7.invalid"
                class="alert alert-danger mt-2"
              >
                Airport Transfer answer is required
              </div>
            </div>-->
           <!-- <div class="form-group mb-3">
              <label class="form-label" for="Address">Address</label>
              <input
                name="address"
                ngModel
                ngModeltype="text"
                class="form-control"
                id="Address"
              />
            </div>-->

            <div style="display: none" class="form-group mb-3">
              <!-- <label class="form-label"  for="Package"
                >Registration <span class="red">*</span></label
              > -->
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col" colspan="3">
                        Registration <span class="red">*</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let pack of packages;
                        index as i;
                        first as isFirst
                      "
                    >
                      <td scope="row">
                        <strong>{{ pack.name }}</strong> <br />{{ pack.desc }}
                      </td>

                      <td style="width: 20%">
                        <!-- <div *ngIf="isFirst" class="alert alert-danger">
                          checked
                        </div> -->
                        <input
                          type="radio"
                          value="{{ pack.id }}"
                          name="package_id"
                          [checked]="package_id === pack.id"
                          (change)="selectPackage()"
                          (change)="package_id = $event.target.value"
                        />

                        <!--
                           
                          id="package{{ i }}"
                          name="package_id"
                          
                          [(ngModel)]="package_id"
                          
                          (change)="selectPackage($event)" -->
                        <!-- [attr.checked]="pack.id == package_id" -->
                        <!-- [(ngModel)]="conference.packages[i].selected" -->
                        <label for="package{{ i }}"
                          >&nbsp;
                          {{ pack.fees }}
                          {{ conference.currency }}</label
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- {{ package_id }} -->
                <div
                  *ngIf="f.submitted && package_id == null"
                  class="alert alert-danger"
                >
                  Registration is required
                </div>
              </div>
            </div>
            <div *ngIf="workshops_num > 0" class="form-group mb-3">
              <!-- <label for="Package"
                >Registration <span class="red">*</span></label
              > -->
              <div class="table-responsive">
                <input type="hidden" name="w_ids[]" />
                <table class="table table-striped">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col" colspan="3">Workshops</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let work of workshops;
                        index as i;
                        first as isFirst
                      "
                    >
                      <th scope="row">{{ work.title }}</th>

                      <td>
                        <!-- <div *ngIf="isFirst" class="alert alert-danger">
                          checked
                        </div> -->
                        <input
                          type="checkbox"
                          value="{{ work.id }}"
                          name="workshop_id"
                          id="workshop{{ i }}"
                          (change)="changeWorkshop($event)"
                        />
                        <!--
                          (change)="workshop_id = $event.target.value" 
                          
                         [checked]="workshop_id === work.id"
                          (change)="selectPackage()"
                          name="package_id"
                          
                          [(ngModel)]="package_id"
                          
                          (change)="selectPackage($event)" -->
                        <!-- [attr.checked]="pack.id == package_id" -->
                        <!-- [(ngModel)]="conference.packages[i].selected" -->
                        <label for="workshop{{ i }}"
                          >&nbsp;
                          {{ work.fees }}
                          {{ conference.currency }}</label
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- {{ package_id }} -->
                <div
                  *ngIf="f.submitted && package_id == null"
                  class="alert alert-danger"
                >
                  Registration is required
                </div>
              </div>
            </div>
            <div style="display: none" class="form-group mb-3">
              <label class="form-label" for="Address"
                >Special Requirements</label
              >
              <textarea
                name="special_requirement"
                ngModel
                ngModeltype="text"
                placeholder="Special Requirements"
                class="form-control"
              ></textarea>
            </div>
          <!-- <div class="form-group mb-3">
              <label class="form-label" for="answer1"
                >Attendee Profile <span class="red">*</span></label
              >
              <select
                name="answer1"
                ngModel
                #answer1="ngModel"
                class="form-control"
                id="answer1"
                required
              >
                <option value="">-- Select --</option>
                <option value="IM">Internal Medicine</option>
                <option value="Neurology">Neurology</option>
                <option value="Ped. Neurology">Ped. Neurology</option>
                <option value="Family Medicine">Family Medicine</option>
                <option value="Pediatrician">Pediatrician</option>
                <option value="ER">ER</option>
                <option value="ICU">ICU</option>
                <option value="Epileptologist">Epileptologist</option>
                <option value="Neurosurgeon">Neurosurgeon</option>
                <option value="GP">G.P</option>
                <option value="Residents">Residents</option>
                <option value="GSK staff">GSK Staff</option>
          
              </select>
              <div
                *ngIf="
                  (answer1.value == '' && answer1.dirty) ||
                  (f.submitted && answer1.value == '')
                "
                class="alert alert-danger"
              >
                Attendee Profile is required
              </div>
            </div>-->
            

           <!-- <div class="form-group form-check mb-3"
           ><input
           name="answer3"
           ngModel
           #answer3="ngModel"
           type="checkbox"
           class="form-check-input"
           value="Yes"
           id="mail_list"
         
         />
              <label class="form-check-label" for="answer1"
                >(Optional) You agree to receive Scientific & Promotional content
                or survey from GSK or GSK's 3rd party through different multi-channels 
                including mobile, email and telephone. 
              </label>
              
            </div>-->
            <div class="form-group form-check mb-3">
              <input
                 name="answer4"
              ngModel
                #answer4="ngModel"
               type="checkbox"
               class="form-check-input"
                value="Yes"
               id="terms_conditions"
               required
                 />

              <label class="form-check-label" for="answer4">
                <span class="red">*</span>  I understand that the information I enter in this form will be collected and stored by the event organizer for communication purposes regarding this event. 


              </label>

              <div
                *ngIf="
                  (answer4.value == '' && answer4.dirty) 
                "
                class="alert alert-danger"
              >
                This field is mandatory!
              </div>
              
            </div>
            
             <!-- <div class="form-group form-check mb-3">
              <input
                 name="answer5"
              ngModel
                #answer5="ngModel"
               type="checkbox"
               class="form-check-input"
                value="Yes"
               id="terms_conditions"
               
                 />

              <label class="form-check-label" for="answer5">
                <span >I would like to receive messages from Johnson & Johnson Vision about products, services or other information that may be of interest to me</span>  


              </label>

              <div
                *ngIf="
                  (answer4.value == '' && answer4.dirty) 
                "
                class="alert alert-danger"
              >
                This field is mandatory!
              </div>
              
            </div>-->
             <!--  <div class="form-group form-check mb-3">
              <input
                 name="answer6"
              ngModel
                #answer6="ngModel"
               type="checkbox"
               class="form-check-input"
                value="Yes"
               id="terms_conditions"
               
                 />

              <label class="form-check-label" for="answer6">
                <span>I would like to receive messages from Johnson & Johnson Institute about medical events and courses.

</span>  


              </label>

              <div
                *ngIf="
                  (answer4.value == '' && answer4.dirty) 
                "
                class="alert alert-danger"
              >
                This field is mandatory!
              </div>
              
            </div>-->
           

            <!-- <div class="form-group mb-3 form-check">
              <input
                name="mail_list"
                ngModel
                type="checkbox"
                class="form-check-input"
                value="Yes"
                id="maillist"
              />
              <label class="form-check-label" for="maillist"
                >I accept to receive email notifications about future
                events.</label
              >
            </div> -->
            <!-- {{ f.value | json }} -->
            <!-- {{ conference | json }} -->
          </div>

          <div
            id="right_side"
            class="d-none col-xs-12 col-sm-12 col-md-4 col-lg-4 pt-4"
          >
            <div class="sticky" id="order_sum">
              <h4 class="summary">Order Summary</h4>
              <div *ngIf="package_id != null">
                <h4>Registration</h4>
                <hr class="line" />
                <div class="align">
                  {{ regName }}
                  <!-- packages[package_id].name  -->
                </div>
                <span class="price-label">Price: </span>
                <span class="price"> {{ regPrice }} {{ currency }}</span>
              </div>

              <hr class="line" />
              <span class="price-label">Subtotal: </span>

              <span class="price"> {{ subTotal }} {{ currency }}</span>
              <br />
              <hr class="line" />
              <div class="subtotal">
                Online Payment Fees <span class="price">+3% </span>
              </div>

              <hr class="line" />
              <div class="total-banner">
                <span class="price-label">Total: </span>

                <span class="price">{{ total }} {{ currency }}</span>
              </div>
              <div class="coupon-div">
                <a
                  class="coupon-link"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  (click)="openDialog()"
                >
                  Have a coupon code?
                </a>
              </div>
            </div>
            <!--div style="padding: 14px">Please note that we are currently accepting only wire transfer & cash deposit as online payment is still under process.</div-->
            <br />

            <!--old footer--->
            <div class="row"></div>
          </div>

          <!-- #END the order summry container -->
        </div>

        <input type="hidden" name="rule_id" ngModel="1" />
        <input
          type="hidden"
          name="conference_id"
          ngModel="{{ conference_id }}"
        />
        <div class="w-100 text-center">
          <br />
<button
  type="submit"
  class="w-100 btn btn-lg btn-primary"
  [disabled]="city_id.value && city_id.value != '2879'"
>
  Submit
</button>        </div>
      </form>
      <!-- {{ f.value | json }} -->
      <!-- Include the PayPal JavaScript SDK -->

      <!-- Set up a container element for the button -->
     
       
    </div>
    
    <br />
    <div
      *ngIf="f.submitted && result?.status == 'success'"
      class="row alert alert-success"
    >
      {{ result.message }}
    </div>
    <div
      *ngIf="f.submitted && result?.status == 'error'"
      class="row alert alert-danger"
    >
      {{ result.message }}
    </div>
  </div>
  <!-- container end-->
<div class="container pt-5 table-responsive" >
    <table class="table">
          <tbody>

            <tr>
              <td>
    

    
This invitation is exclusive to healthcare professionals
©️2026 Insulet Corporation. Insulet, Omnipod and the Omnipod logo are trademarks or registered trademarks of Insulet Corporation. All rights reserved. All other trademarks are the property of their respective owners. The use of third-party trademarks does not constitute an endorsement or imply a relationship or other affiliation. 
<br><br>
INS-OHS-04-2026-00313 v1.0

<br>
    <br>
              </td>
            </tr>
            <!--<tr><td>  *We take your privacy seriously. We will only use your personal data in accordance with our Privacy Laws. Your personal data will not be used for direct marketing purposes, unless you have indicated otherwise.
</td></tr>-->
          </tbody>
        </table>
<!--<div class="row align-items-center">
  <div class="col">
    <table class="table " > 
      <thead >
        <tr>
          <th scope="col" >
            Call for Reporting
  
          </th >
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Department of Pharmacovigilance & Drug Information
Directorate General of Pharmaceutical Affairs & Drug Control
<br>
Ministry of Health, Sultanate of Oman
<br>
Phone Nos. 0096822357687 / 0096822357686
Fax: 0096822358489
<br>
Email: pharma-vigil@moh.gov.om 
<br>
Website: www.moh.gov.om

          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col">
    <table class="table " dir="rtl" > 
      <thead >
        <tr>
          <th scope="col" >
            الاتصال للإبلاغ
  
          </th >
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            دائرة المعلومات الدوائية
المديرية العامة للصيدلة و الإدارة العامة
وزارة الصحة، سلطنة عمان
<br>
هاتف: 0096822357687 / &nbsp; 0096822357686
<br>
فاكس: 0096822358489
<br>
البريد الالكتروني:  pharma-vigil@moh.gov.om
  <br>
الموقع الالكتروني: www.moh.gov.om 
<br>
<br>


          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
 
</div>-->
    
  </div>

  <div class="footer m">
    <img src="./assets/img/bottom.png" class="blob-bright img-fluid" />
    <br>
    
  </div>
</section>
<!-- ts schedule end-->
